import { Dictionary } from "../store/models/common_types";

export enum RevisionValues {
  "PreQ" = "PreQ",
  "-1M" = "1 Month",
  "-3M" = "3 Months",
}
export interface LineItemMeta {
  dapparameterid: number;
  header: string;
  display_unit: string;
}

export interface AddColTableData {
  name: string;
  sli_id: number;
  dapparameterid: number;
  header: string;
  display_unit: string;
}
export interface LineItemMonitorMeta {
  line_items: Array<LineItemMeta>;
  period_list: Array<string>;
  period_range: Dictionary<number>;
  relative_periods: Array<string>;
  is_models_only: boolean;
  user_id: number;
  filings_period: string;
  chart_estimated_period: string;
  current_quarter: string;
  companyname: string;
  companyid: number;
  currency_value: string;
  entitled: boolean;
  line_count: number;
  period_values: Array<number>;
  quarters: Array<string>;
  rowHeaders?: any; // this is added by FE code, this won't come from API
  lim_enabled: boolean;
}
export interface LineItemMonitorMetaResponse {
  data: LineItemMonitorMeta;
  status: string;
}

export interface UpdateLineItemParams {
  ticker: string;
  line_ids: Array<number>;
  append_lines?: boolean;
}

export interface TabData {
  dpid: number;
  name: string;
}

export interface TabSliData {
  name: string;
  sli_id: number;
  dapparameterid: number;
}
export interface SuggestedLineItems {
  tab_full_name: string;
  tab_short_name: string;
  // tab_data is received in API response
  tab_data?: Array<TabData>;
  // tab_data is moved to tab_sli_data in FE code as underlying component expects tab_sli_data instead of tab_data
  tab_sli_data?: Array<TabSliData>;
}
export interface LimTabDetailsResponse {
  status: string;
  data: Array<SuggestedLineItems>;
}

export interface GridHeaderLevel1 {
  label: string;
  subscript?: string;
  rowspan?: string;
  colspan?: string;
}

export interface GridHeaderLevel2 {
  label: string;
}
export interface GridHeader {
  level1: Array<GridHeaderLevel1>;
  level2: Array<Array<GridHeaderLevel2>>;
}

export class CellValue {
  value: string;
  color: string;
}
export class GridValue {
  header: string;
  id: number;
  values: Array<Array<CellValue>>;
}

export interface LineItemLinksResponse {
  status: string;
  sch_links: Dictionary<any>;
  line_ids: Array<number>;
  nmv_links: Dictionary<any>;
}
